import { IwocaLogo } from '@iwoca/orion';
import clsx from 'clsx';
import { handleLogoTracking } from 'components/Navigation/Tracking/NavigationTracking';
import { useLocale } from 'hooks/useLocale';
import { Link } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import styles from './Logo.module.css';

type TProps = {
  iconOnly?: boolean;
};

export const Logo = ({ iconOnly = false }: TProps) => {
  const { locale } = useLocale();

  return (
    <Link
      to={PATH_NAMES.home()}
      onClick={() => handleLogoTracking(locale)}
      className={styles.logoLink}
      data-testid="iwoca-logo"
    >
      <IwocaLogo
        iconOnly={iconOnly}
        className={clsx(styles.logo, { [styles['iconOnly']]: iconOnly })}
      />
    </Link>
  );
};
